import React from "react";
import { Avatar, CardHeader } from "@mui/material";

// This is a helper for MobileHomeScreen to create a CardHeader avatar with custom background and icon
interface CardHeaderAvatarProps {
    icon: React.ReactNode;
    avatarBg: string;
}

const CardHeaderAvatar: React.FC<CardHeaderAvatarProps> = ({ icon, avatarBg }) => (
    <Avatar sx={{ bgcolor: avatarBg, width: 40, height: 40 }}>
        {icon}
    </Avatar>
);

export default CardHeaderAvatar;
